//Form Display
const formToggles = document.getElementsByClassName('form-toggle');

Array.from(formToggles).forEach((toggle) => {
  // Click event
  toggle.addEventListener('click', function (event) {
    const target = toggle.getAttribute('data-target');
    document.getElementById(target).classList.toggle('active');
  });
});

// Map
const long = 168.959721;
const lat = -45.029924;
// Vineyard
const vineyardLong = 168.95107698094282;
const vineyardLat = -45.0302439724623;

// Tasting Room
const tastingLong = 168.96937151151133;
const tastingLat = -45.028888648680166;



// Map
mapboxgl.accessToken =
  'pk.eyJ1IjoicGF1bG50IiwiYSI6ImNrc25xMTB0ODBzbTczMm1yZ2F2bmxqbGMifQ.pHFu4dURHusvfboJSZkyJA';
var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v10',
  center: [long, lat],
  zoom: 13,
});

// Add zoom and rotation controls to the map.
map.addControl(new mapboxgl.NavigationControl());

// disable map zoom when using scroll
// map.scrollZoom.disable();

var vineyard = document.createElement('div');
vineyard.className = 'map-marker-vineyard';

var tasting = document.createElement('div');
tasting.className = 'map-marker-tasting';

var vineyardMarker = new mapboxgl.Marker(vineyard).setLngLat([vineyardLong, vineyardLat]).addTo(map); // add the marker to the map
var tastingMarker = new mapboxgl.Marker(tasting).setLngLat([tastingLong, tastingLat]).addTo(map); // add the marker to the map

// Address toggle
const addressToggle = Array.from(document.querySelectorAll('.address-toggle h2'));
const addresses = Array.from(document.querySelectorAll('.address'));
const contacts = Array.from(document.querySelectorAll('.contact-item'));

addressToggle.forEach((toggle) => {
  toggle.onclick = () => {
    addressToggle.forEach((toggle) => toggle.classList.remove('active'));
    addresses.forEach((address) => address.classList.toggle('active'));
    contacts.forEach((contact) => contact.classList.toggle('active'));
    toggle.classList.add('active');
  }  
});


// const urlSearchParams = new URLSearchParams(window.location.search);
// const params = Object.fromEntries(urlSearchParams.entries());
// console.log(params);
// ?contact_posted=true#contact_form
